import React from "react";
import { Button, Avatar } from "antd";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./Navbar.css";
import logo from "../../assets/logo.png";
import { useAuthHook } from "../Auth/hooks/useAuth";
import { ROUTES, TITLE } from "../../utils/constants";

const Navbar = () => {
    const { logout, username } = useAuthHook();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate(ROUTES.LOGIN);
    };

    return (
        <nav className="navbar">

            <div className="navbar-left">
                <img src={logo} alt="Company Logo" className="company-logo" />
            </div>

            <div className="nav-center">
                <span className="nav-title">{TITLE}</span>
            </div>

            <div className="nav-right">

                <div className="user-info">
                    <Avatar size="small" icon={<UserOutlined />} />
                    <span className="username">{username}</span>
                </div>

                <Button
                    type="default"
                    size="small"
                    icon={<LogoutOutlined />}
                    onClick={handleLogout}
                    className="logout-btn"
                >
                    Logout
                </Button>

            </div>
        </nav>
    );
};

export default Navbar;